<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"
            ><i class="icon-close"></i
          ></a>
          <h3 class="modal-title">撥出對象-多保單篩選</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 pl-0">
              <div
                class="panel insurance-item"
                v-for="(insure, i) in insurances"
                :key="`insure-item-${i}`"
              >
                <div class="no">{{ i + 1 }}</div>
                <div class="form-group form-group-inline">
                  <label>保單號碼</label>
                  <input
                    type="text"
                    class="form-control form-control-inline"
                    maxlength="10"
                    v-model="insure.policyNumber"
                    @input="doCheckInsNo(i, insure.policyNumber)"
                  />
                </div>
                <span
                  class="text-red dial-form-status"
                  v-if="
                    insure.policyNumber.length == 0 || insure.insureNoReturnMsg
                  "
                >
                  {{ insure.insureNoReturnMsg }}
                </span>
                <span class="text-green dial-form-status" v-else>
                  檢核正確
                </span>
                <div
                  v-if="insure.policyLoading"
                  class="section-loading d-inline-block"
                  style="height:20px; width:30px"
                ></div>
                <button
                  v-if="i > 0"
                  class="btn btn-default m-0 delete"
                  @click="deleteInsurance(i)"
                  style="right:16px;"
                >
                  刪除
                </button>
              </div>
              <div
                class="panel insurance-item add text-center"
                role="button"
                @click="AddInsurance()"
              >
                <div class="content text-center">
                  <i class="icon-add_new text-orange"></i>
                  <span class="text ml-1">其他保單</span>
                </div>
              </div>
              <div class="action text-right">
                <a @click="$emit('close')" role="button" class="btn btn-default"
                  >取消</a
                >
                <a @click="submit()" role="button" class="btn btn-primary"
                  >確定</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { checkInsByNo } from "@/service";

export default {
  name: "DialOutInsuranceModal",
  mixins: [commonMixin],
  data() {
    return {
      insurances: [
        {
          policyNumber: "",
          policyLoading: false,
          insureNoReturnMsg: "",
          ceclcno: "",
          ceplcno: ""
        }
      ]
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    AddInsurance() {
      if (this.insurances.length < 10) {
        this.insurances.push({
          policyNumber: "",
          policyLoading: false,
          insureNoReturnMsg: "",
          ceclcno: "",
          ceplcno: ""
        });
      } else {
        this.setToastMsg("最多輸入10筆保單號碼!");
      }
    },
    submit() {
      var isDataCorrect = true;

      for (var i = 0; i < this.insurances.length; i++) {
        let insurance = this.insurances[i];
        if (insurance.policyNumber == "") {
          this.setToastMsg("尚有欄位未填，請確認");
          isDataCorrect = false;
          break;
        }
        if (insurance.insureNoReturnMsg) {
          this.setToastMsg("尚有保單號碼格式錯誤或查無資料，請確認!");
          isDataCorrect = false;
          break;
        }
      }
      if (isDataCorrect) {
        this.$emit("submit", this.insurances);
      }
    },
    doCheckInsNo(index, insure_no) {
      if (!insure_no || insure_no.length != 10) {
        this.insurances[index].insureNoReturnMsg = "請輸入完整10位保單號碼";
        return;
      }

      if (
        this.insurances.filter(ele => ele.policyNumber === insure_no).length > 1
      ) {
        this.insurances[index].insureNoReturnMsg = "保單號碼重複";
        return;
      }

      this.insurances[index].policyLoading = true;

      // 以保單號碼查詢服務件
      const cedvno3 = this.$store.state.userInfo.divNo.slice(0, 3);
      checkInsByNo(this.$store.state.userInfo.id, cedvno3, insure_no).then(
        result => {
          if (result && result.header.status == "200" && result.body) {
            if (result.body.returncode != "0") {
              this.insurances[index].insureNoReturnMsg = result.body.returnmsg;
            } else {
              this.insurances[index].insureNoReturnMsg = "";
              this.insurances[index].ceclcno = result.body.detail ? result.body.detail.ceclcno : ''; //收費代號
              this.insurances[index].ceplcno = result.body.detail ? result.body.detail.ceplcno : ''; //保單號碼              
            }
          } else {
            this.insurances[index].insureNoReturnMsg = "連線異常";
          }
          this.insurances[index].policyLoading = false;
        }
      );
    },
    deleteInsurance(i) {
      this.insurances.splice(i, 1);
    }
  }
};
</script>
<style lang="css" scoped>
.delete{
  position: absolute !important;
}
@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    .delete{
        position: relative !important;
        margin-left: 30px !important;
    }
}
</style>